import { render } from "./ButtonStartTest.vue?vue&type=template&id=ef0c89ba&ts=true"
import script from "./ButtonStartTest.vue?vue&type=script&lang=ts"
export * from "./ButtonStartTest.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__